import * as s from "./website-black-testimonial-presentation.scss";
import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {IWebsiteBlackTestimonialPresentation} from "./types/IWebsiteBlackTestimonialPresentation";
import {WebsiteBlackUnionLineComponent} from "../../union/line/WebsiteBlackUnionLineComponent";

export class WebsiteBlackTestimonialPresentationComponent extends Component {

    public p: IWebsiteBlackTestimonialPresentation;

    public buttons: Component;

    constructor(p: IWebsiteBlackTestimonialPresentation) {
        super();
        this.p = p;
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackTestimonialPresentation}">
                <div class="${s.whiteShadow}"></div>
                <h1 class="${s.title}" ${p.titleMaxWidth ? `style="max-width: ${p.titleMaxWidth}px;"` : ``}>
                    ${p.title}
                </h1>
                <div class="${s.stats}">
                    ${p.stats.map(value => `
                    <div class="${s.stat}">
                        <div class="${s.value}">
                            ${value.value}
                        </div>
                        <div class="${s.label}">
                            ${value.label}
                        </div>
                        <div class="${s.shadow}"></div>
                    </div>
                    `).join("")}
                </div>
                <div class="${s.line}">
                    ${this.draw(new WebsiteBlackUnionLineComponent("green"))}
                </div>
                <div class="${s.customer}">
                    <div class="${s.texts}">
                        <div class="${s.name}">
                            ${p.customerName}
                        </div>
                        ${p.customerDescription}
                    </div>
                    <div class="${s.image}">
                        <img alt="${p.title}" src="${p.customerImage}"/>
                    </div>
                </div>
            </div>
        `;
    }
}